export function getProductDescriptionString(description?: string | null, customDescription?: string | null): string {
    if (description && customDescription) {
        return `${description}
        
        ${customDescription}`;
    }
    return description ?? customDescription ?? '';
}
